import { render, staticRenderFns } from "./InventarioBowtie.vue?vue&type=template&id=8a32f62e&scoped=true&"
import script from "./InventarioBowtie.vue?vue&type=script&lang=js&"
export * from "./InventarioBowtie.vue?vue&type=script&lang=js&"
import style0 from "./InventarioBowtie.vue?vue&type=style&index=0&id=8a32f62e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a32f62e",
  null
  
)

export default component.exports